var exports = {
  "J": "xaee3c4fa--1e29e0--author-label",
};

module.exports = exports;
